// Translation loader utility for lazy loading language files
// This module provides critical translations for immediate render and lazy loads full translations

// Critical translations needed before full translation files load
// These cover the loading states and common UI elements
export const criticalTranslations = {
  en: {
    common: {
      loading: 'Loading...',
      back: 'Back',
      next: 'Next',
      cancel: 'Cancel',
      save: 'Save',
      processing: 'Processing...',
    },
    auth: {
      login: {
        title: 'Login to Your Account',
        description: 'Welcome back! Please enter your details.',
        emailLabel: 'Email',
        emailPlaceholder: 'Enter your email',
        passwordLabel: 'Password',
        passwordPlaceholder: 'Enter your password',
        loginButton: 'Login',
        loggingInButton: 'Logging in...',
      },
    },
    components: {
      loadingspinner: {
        loadingDefault: 'Loading...',
        defaultMessage: 'Please wait while we load your data.',
      },
    },
  },
  tr: {
    common: {
      loading: 'Yükleniyor...',
      back: 'Geri',
      next: 'İleri',
      cancel: 'İptal',
      save: 'Kaydet',
      processing: 'İşleniyor...',
    },
    auth: {
      login: {
        title: 'Hesabınıza Giriş Yapın',
        description: 'Tekrar hoş geldiniz! Lütfen bilgilerinizi girin.',
        emailLabel: 'E-posta',
        emailPlaceholder: 'E-posta adresinizi girin',
        passwordLabel: 'Şifre',
        passwordPlaceholder: 'Şifrenizi girin',
        loginButton: 'Giriş Yap',
        loggingInButton: 'Giriş yapılıyor...',
      },
    },
    components: {
      loadingspinner: {
        loadingDefault: 'Yükleniyor...',
        defaultMessage: 'Verileriniz yüklenirken bekleyin.',
      },
    },
  },
};

// Cache for loaded translations
const translationCache = {};

// Load the full translation file for a given language
export const loadTranslations = async (lang) => {
  // Return from cache if already loaded
  if (translationCache[lang]) {
    return translationCache[lang];
  }

  try {
    // Dynamic import based on language
    const module = lang === 'tr'
      ? await import('./tr.js')
      : await import('./en.js');

    translationCache[lang] = module.default;
    return module.default;
  } catch (error) {
    console.error(`Failed to load translations for ${lang}:`, error);
    // Fall back to English if loading fails
    if (lang !== 'en') {
      return loadTranslations('en');
    }
    // If even English fails, return critical translations
    return criticalTranslations.en;
  }
};

// Deep merge function to combine critical translations with full translations
export const mergeTranslations = (critical, full) => {
  if (!full) return critical;

  const result = { ...full };

  // Critical translations are already included in full, so just return full
  return result;
};

// Preload the user's preferred language in the background
export const preloadUserLanguage = () => {
  const savedLang = localStorage.getItem('language') || 'en';
  // Start loading in the background
  loadTranslations(savedLang);
};
